module.exports = __webpack_public_path__ + "static/media/21ECLAC31.0265161f.jpg";